<template>
    <div id="jobs-carousel-container" class="swiper-container relative">
        <div id="jobs-carousel" class="swiper">
            <div ref="swiperWrapper" class="swiper-wrapper">
                <div v-for="(job, i) in jobs" :key="i" class="swiper-slide" style="height: auto">
                    <JobCard
                        :index="i"
                        :url="localePath(`/job-seeker/jobs/${job.slug}`)"
                        :title="job.title"
                        :location="
                            (job.regions.length ? job.regions.map((x) => x.title).join(', ') : '') +
                            (job.country && job.regions.length ? ', ' : '') +
                            (job.country ? job.country.name : '')
                        "
                        :employment-type="job.employment_type.name"
                        :sector="job.sector ? job.sector.name : ''"
                        :deadline="job.deadline ? $dayjs(job.deadline * 1000).format('YYYY. MMMM DD.') : ''"
                        :is-featured="job.is_highlighted"
                    />
                </div>
            </div>
        </div>

        <div class="swiper-nav-container">
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';

import JobCard from '@/components/Cards/JobCard/JobCard';

export default {
    name: 'JobsCarousel',
    components: {
        JobCard,
    },
    props: {
        jobs: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        this.jobsCarousel = new Swiper('#jobs-carousel', {
            slidesPerView: 1.2,
            spaceBetween: 20,
            resistance: true,
            resistanceRatio: 0,
            allowTouchMove: this.$device.isMobileOrTablet || window.innerWidth < 768,
            speed: 500,
            breakpoints: {
                500: {
                    slidesPerView: 1.6,
                },
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
            pagination: {
                el: '#jobs-carousel-container .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '#jobs-carousel-container .swiper-button-next',
                prevEl: '#jobs-carousel-container .swiper-button-prev',
            },
            on: {
                afterInit: () => {
                    this.equalizeCardHeights();
                },
                resize: () => {
                    this.equalizeCardHeights();
                },
                orientationchange: () => {
                    this.equalizeCardHeights();
                },
            },
            // autoplay: {
            //     delay: 6000,
            // },
        });
    },
    beforeDestroy() {
        if (this.jobsCarousel) {
            this.jobsCarousel.destroy();
        }
    },
    methods: {
        equalizeCardHeights() {
            this.$refs.swiperWrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
                slide.querySelector('.job-card__title').style.height = 'unset';
                slide.querySelector('.job-card__location').style.height = 'unset';
                slide.querySelector('.job-card__details').style.height = 'unset';
            });

            let highestTitleHeight = 0;
            let highestLocationHeight = 0;
            let highestDetailsHeight = 0;

            this.$refs.swiperWrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
                const titleHeight = slide.querySelector('.job-card__title').getBoundingClientRect().height;
                const locationHeight = slide.querySelector('.job-card__location').getBoundingClientRect().height;
                const detailsHeight = slide.querySelector('.job-card__details').getBoundingClientRect().height;

                if (titleHeight > highestTitleHeight) {
                    highestTitleHeight = titleHeight;
                }
                if (locationHeight > highestLocationHeight) {
                    highestLocationHeight = locationHeight;
                }
                if (detailsHeight > highestDetailsHeight) {
                    highestDetailsHeight = detailsHeight;
                }
            });

            this.$refs.swiperWrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
                slide.querySelector('.job-card__title').style.height = highestTitleHeight + 'px';
                slide.querySelector('.job-card__location').style.height = highestLocationHeight + 'px';
                slide.querySelector('.job-card__details').style.height = highestDetailsHeight + 'px';
            });
        },
    },
};
</script>

<style>
.swiper-slide .job-card__details {
    margin-bottom: 0;
}
</style>
